import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  Divider
} from "@mui/material";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import userblockicon from "../../../../assests/userblockicon.svg";
import "./stopPayout.css";

const StopPayoutComponent = ({
  formData,
  handleChange,
  handleSubmit,
  loading,
  partners,
  openDialog,
  handleCloseDialog,
  navigate,
  handleOpenSelect,
  openSelect,
  handleScroll,
  hasMore,
  handleLoadMore,
  loadMoreLoading
}) => {
  return (
    <div className="stop-payout-layout">
      <Sidebar />
      <div className="stop-payout-content">
        <Box className="stop-payout-header">
          <IconButton onClick={() => navigate(-1)} className="stop-payout-back-button">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" className="stop-payout-title">
            Stop Payout
          </Typography>
        </Box>

        <div className="stop-payout-container">
          <Card className="stop-payout-card">
            <CardContent>
              <form onSubmit={handleSubmit} className="stop-payout-form">
                <div className="stop-payout-form-field">
                  <FormControl fullWidth>
                    <InputLabel className="stop-payout-select-label">Select Partner</InputLabel>
                    <Select
                      name="franchiseeId"
                      value={formData.franchiseeId}
                      onChange={handleChange}
                      onOpen={() => handleOpenSelect(true)}
                      onClose={() => handleOpenSelect(false)}
                      open={openSelect}
                      label="Select Partner"
                      className="stop-payout-partner-select"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            overflow: 'auto',
                          },
                          onScroll: handleScroll,
                        },
                      }}
                    >
                      {partners.map((partner) => (
                        <MenuItem
                          key={partner.id}
                          value={partner.id}
                          className="stop-payout-partner-item"
                        >
                          <div className="stop-payout-partner-info">
                            <span className="stop-payout-partner-name">{partner.name}</span>
                            <span className="stop-payout-partner-id">ID: {partner.id}</span>
                          </div>
                        </MenuItem>
                      ))}

                      {/* Load More Button */}
                      {hasMore && partners.length > 0 && (
                        <>
                          <Divider />
                          <MenuItem 
                            onClick={handleLoadMore} 
                            disabled={loadMoreLoading}
                            className="stop-payout-load-more-item"
                          >
                            <div className="stop-payout-load-more-button">
                              {loadMoreLoading ? (
                                <>
                                  <CircularProgress size={20} style={{ marginRight: "10px" }} />
                                  Loading more...
                                </>
                              ) : (
                                "Load More"
                              )}
                            </div>
                          </MenuItem>
                        </>
                      )}

                      {loading && partners.length === 0 && (
                        <MenuItem disabled>
                          <CircularProgress size={20} style={{ marginRight: "10px" }} />
                          Loading...
                        </MenuItem>
                      )}
                      
                      {!hasMore && partners.length > 0 && (
                        <MenuItem disabled className="stop-payout-no-more-item">
                          No more partners
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>

                <div className="stop-payout-form-actions">
                  <Button
                    type="submit"
                    variant="contained"
                    className="stop-payout-submit-button"
                    disabled={!formData.franchiseeId || loading}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>

        <Dialog open={openDialog} onClose={handleCloseDialog} className="stop-payout-block-dialog">
          <DialogTitle className="stop-payout-dialog-title">
            <img src={userblockicon} alt="" style={{ height: "70px", width: "70px" }} />
            <Typography variant="h5" className="stop-payout-dialog-heading">
              Payout Blocked
            </Typography>
          </DialogTitle>
          <DialogContent className="stop-payout-dialog-content">
            <Typography variant="body1" className="stop-payout-dialog-message">
              Payout Has Been Blocked Partner <br /> No Longer Eligible To Receive
            </Typography>
          </DialogContent>
          <DialogActions className="stop-payout-dialog-actions">
            <Button onClick={handleCloseDialog} className="stop-payout-dialog-button">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default StopPayoutComponent;